/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { Permissions } from 'projects/app-core/src/auth/models/roles';
import { IAnyoError } from '../../../models/error/errorResponse';
import { IAnyoTherapist } from 'projects/admin/src/app/models/IAnyoTherapist';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import {
  SessionAddRemarkRequest,
  SessionOverrideRequest,
  SessionsService,
} from 'projects/app-core/src/app/session/service/sessions.service';
import { ToastService } from '../../../services/toastr.service';
import { AutocompleteDataSourceItem } from 'ng-zorro-antd/auto-complete';
import {
  MeetParticipant,
  PolicyBookingTrace,
  SessionGridFilterData,
  SessionGridResponse,
  SessionGridResponseData,
  TherapistFilterData,
} from '../../models/sessionGridResponse';
import { UpdateSessionRequest } from '../../models/SessionRequest';
import { SessionFeedbackFormSubmitRequest } from '../../models/sessionFeedbackFormSubmitRequest';
import {
  AppointmentStatus,
  SessionTags,
} from '../../models/TherapistAppointment';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SessionGridRequest } from '../../models/sessionGridRequest';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { TherapyVerticals } from 'projects/app-core/src/models/TherapyVerticals';
import { TherapyConcerns } from 'projects/app-core/src/models/TherapyConcerns';
import { MasterDataResponse } from 'projects/admin/src/app/models/masterDataResponse';
import { TherapyPlansService } from 'projects/admin/src/app/services/therapy-plans.service';
import { TherapyPlansAppResponse } from '../../../models/TherapyPlansAppResponse';
import { ActiveTherapyPlansResponse } from '../../../models/ActiveTherapyPlansResponse';
import { TherapistService } from 'projects/admin/src/app/services/therapist.service';
import { TimeRangesResponse } from 'projects/admin/src/app/models/timeRangesRequestResponse';
import {
  TherapistAppResponseV2,
  TherapistTags,
} from 'projects/admin/src/app/models/TherapistV2AppResponse';
import { MasterdataService } from 'projects/admin/src/app/services/masterdata.service';
import { AnyoPackSubscriptionAppResponse } from 'projects/admin/src/app/models/packs/AnyoPackSubscriptionAppResponse';
import { PackService } from 'projects/admin/src/app/services/packs.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AdminAddRewardToLedger,
  RewardService,
} from 'projects/admin/src/app/services/rewards.service';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}

interface TherapistCheckBoxOptions {
  label: string;
  value: string;
  data: TherapistFilterData;
  checked: boolean;
}

export interface SearchUserResponse {
  email: string;
  id: string;
  name: string;
}

export interface SlotAvailability {
  date: string;
  available: boolean;
  start: string;
  end: string;
}

export interface AdminTherapistBookingRequest {
  userEmail: string;
  therapistId: string;
  appointmentDateTime: number;
  appointmentServiceType: AppointmentServiceType;
  emergencyAppointment: boolean;
  planSubscriptionId?: string;
  packSubscriptionId?: string;
  sessionNumber?: string;
  primaryTherapist?: boolean;
  sessionMinutes?: number;
  offline?: boolean;
}

enum AppointmentServiceType {
  Therapist = 'Therapist',
}

interface therapistSelectOptions {
  label: string;
  value: string;
}

interface CheckboxOptions {
  label: string;
  value: TimeRangesResponse;
  checked: boolean;
  disabled: boolean;
  isOverlapUnavailable?: boolean;
}

interface CheckboxOptions {
  label: string;
  value: TimeRangesResponse;
  checked: boolean;
  disabled: boolean;
  isOverlapUnavailable?: boolean;
}

@Component({
  selector: 'app-session-table',
  templateUrl: './session-table.component.html',
  styleUrls: ['./session-table.component.scss'],
})
export class SessionTableComponent {
  @Output() reloadTableEvent = new EventEmitter<void>();
  @Input() inputTableData: SessionGridResponse | undefined;
  @Output() resetFilterEvent = new EventEmitter<void>();
  @Output() pageSizeChangeEvent = new EventEmitter<number>();
  @Output() clientSearchEvent = new EventEmitter<string>();
  @Output() sessionDateFilterEvent = new EventEmitter<Date[]>();
  @Output() sessionDateSortEvent = new EventEmitter<string | null>();
  @Output() therapistRatingSortEvent = new EventEmitter<string | null>();
  @Output() sessionStatusFilterEvent = new EventEmitter<string[]>();
  @Output() partnerIdFilterEvent = new EventEmitter<string[]>();
  @Output() partnerNameFilterEvent = new EventEmitter<string[]>();
  @Output() therapistFilterEvent = new EventEmitter<string[]>();
  @Output() pageChangeEvent = new EventEmitter<number>();
  @Output() hideTestBookingEvent = new EventEmitter<boolean>();
  @Output() viewPatientDetailsEvent = new EventEmitter<string>();
  @Output() confirmAppointmentEvent = new EventEmitter<string>();
  @Output() assignGoogleMeetEvent = new EventEmitter<string>();
  @Output() cancelAppointmentEvent = new EventEmitter<{
    userName: string;
    userEmail: string;
    id: string;
  }>();
  @Output() updateAppointmentEvent = new EventEmitter<UpdateSessionRequest>();
  @Output() exportDataEvent = new EventEmitter<void>();
  @Output() feedbackSubmitEvent =
    new EventEmitter<SessionFeedbackFormSubmitRequest>();
  showFeedBackForm: boolean = false;
  feedbackFormSubmitLoading: boolean = false;
  @Input() showBarIcon!: boolean;
  updateAppointmentSubmitLoading: boolean = false;
  @Input() therapistWithId!: Array<therapistSelectOptions> | undefined;
  @Input() showUpdateButtonPortal!: boolean;
  @Input() tableQuery: SessionGridRequest | undefined;
  @Input() masterData: MasterDataResponse | undefined;
  @Output() sessionFilterTagEvent = new EventEmitter<string[]>();
  @Input() selectedTab!: number;
  onlinePacks = true;
  onlinePlans = true;

  protected readonly SessionStatus = AppointmentStatus;

  protected readonly SessionTags = SessionTags;

  selectedSession: SessionGridResponseData | undefined;
  selectedStatus!: string;
  sessionCompleted = 'Yes';
  feedbackRemarks: string | undefined;
  showRemarksModal = false;
  showNewSessionModal = false;
  newSessionSubmitProgress = false;
  activeTherapists: IAnyoTherapist[] = [];
  therapistByVerticalConcern: TherapistAppResponseV2[] = [];

  selectedUser: string | undefined;
  selectedUserId: string | undefined;
  bookSessionDateTimeSpinner: boolean = false;
  selectedDuration: number = 30;

  pageSize: number = 10;
  pageSizeOptions = [10, 20, 50, 100];
  clientPhoneEmailSearch: string = '';
  sessionStatusCheckBoxOptions: CheckBoxOptions[] = [];
  partnerIdCheckBoxOptions: CheckBoxOptions[] = [];
  therapistCheckBoxOptions: TherapistCheckBoxOptions[] = [];
  partnerCompanyNameCheckBoxOptions: CheckBoxOptions[] = [];
  sessionTagFilterOption: CheckBoxOptions[] = [];
  selectedSessionFilterStatus: string[] = [];
  selectedPartId: string[] = [];
  selectedTherapists: string[] = [];
  sessionColumnFilterDate: Date[] | undefined;
  expandSet = new Set<string>();
  @Input() showNewBookingBtn: boolean = false;
  @Input() canShowOverrideButton: boolean = false;
  visibleUpdateAppointment: boolean = false;
  selectedTherapistString!: string;
  startTime!: Date;
  updateDate!: Date;
  selectedSessionTag: string[] = [];
  onDurationSelected(sessionMinutes: number) {
    this.selectedDuration = sessionMinutes;
    this.checkBoxTimeRangeOptions.forEach((data) => (data.checked = false));
    this.refreshTimeSlots();
  }

  refreshTimeSlots() {
    if (
      !this.checkBoxTimeRangeOptions ||
      this.checkBoxTimeRangeOptions.length === 0
    ) {
      return;
    }

    const duration = this.selectedDuration || 30;

    // Helper to check if a slot is fundamentally unavailable
    const isSlotUnavailable = (slot: CheckboxOptions): boolean => {
      return !slot.value.available || slot.value.notAvailableSlotExists;
    };

    // First, set the disabled state for fundamentally unavailable slots
    this.checkBoxTimeRangeOptions.forEach((slot) => {
      if (isSlotUnavailable(slot)) {
        slot.disabled = true;
        slot.isOverlapUnavailable = false;
      } else {
        slot.disabled = false;
        slot.isOverlapUnavailable = false;
      }
    });

    const firstSlotStartMs = this.parseTime(
      this.checkBoxTimeRangeOptions[0].value.start,
    ).getTime();

    // Helper to parse time and adjust if it crosses midnight
    const getAdjustedMs = (timeStr: string): number => {
      let ms = this.parseTime(timeStr).getTime();
      if (ms < firstSlotStartMs) {
        ms += 24 * 60 * 60 * 1000; // Add 24 hours in milliseconds
      }
      return ms;
    };

    // Now, check each slot for overlaps/insufficient duration
    const len = this.checkBoxTimeRangeOptions.length;
    for (let i = 0; i < len; i++) {
      const currentSlot = this.checkBoxTimeRangeOptions[i];
      if (isSlotUnavailable(currentSlot)) {
        continue;
      }

      const startMs = getAdjustedMs(currentSlot.value.start);

      // Accumulate available time from consecutive available slots starting at i
      let accumulatedTimeMs = 0;
      let lastEndMs = startMs;

      for (let j = i; j < len; j++) {
        const checkSlot = this.checkBoxTimeRangeOptions[j];
        if (isSlotUnavailable(checkSlot)) {
          break; // Hit an unavailable slot, cannot span further
        }

        const slotStartMs = getAdjustedMs(checkSlot.value.start);
        const slotEndMs = getAdjustedMs(checkSlot.value.end);

        // Check if there is a gap between the end of the last checked slot and the start of this slot
        if (slotStartMs > lastEndMs) {
          break; // Hit a gap
        }

        // Add this slot's duration to our contiguous available block
        accumulatedTimeMs += slotEndMs - slotStartMs;
        lastEndMs = slotEndMs;

        if (accumulatedTimeMs >= duration * 60 * 1000) {
          break; // We have enough contiguous available time
        }
      }

      if (accumulatedTimeMs < duration * 60 * 1000) {
        currentSlot.disabled = true;
        currentSlot.isOverlapUnavailable = true;
      }
    }
  }

  // Helper to parse "hh:mm am/pm" into Date
  private parseTime(timeStr: string): Date {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
    }
    if (modifier.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  closeNewSessionModal() {
    this.showNewSessionModal = false;
    this.selectedUser = '';
    this.selectedActivePlanId = '';
    this.selectedActivePlan = undefined;
    this.date = null;
    this.selectedTherapist = undefined;
    this.checkBoxTimeRangeOptions = [];
    this.prevCheckBoxTimeRangeOptions = [];
    this.selectedDuration = 30;
    this.userSearchResults = [];
    this.userActivePlans = [];
    this.isIntroSession = false;
  }

  closeNewSessionPackModal() {
    this.showNewSessionPacksModal = false;
    this.selectedUser = '';
    this.selectedActivePackId = '';
    this.selectedActivePack = undefined;
    this.date = null;
    this.selectedTherapist = undefined;
    this.checkBoxTimeRangeOptions = [];
    this.prevCheckBoxTimeRangeOptions = [];
    this.selectedDuration = 30;
    this.userSearchResults = [];
    this.userActivePacks = [];
    this.selectOptionsPacks = [];
    this.isIntroSession = false;
  }

  closeUpdateModal() {
    this.visibleUpdateAppointment = false;
  }

  resetValues() {
    this.clientPhoneEmailSearch = '';
    this.sessionColumnFilterDate = undefined;
    this.pageSize = 10;
    this.selectedSessionFilterStatus = [];
    this.selectedSessionTag = [];
  }

  submitFeedBack() {
    if (!this.selectedSession) {
      return;
    }
    this.feedbackRemarks = this.feedbackRemarks?.trim();
    if (!this.feedbackRemarks) {
      this.toastService.showAnyoErrorToast('Please enter remarks');
      return;
    }

    const request: SessionFeedbackFormSubmitRequest = {
      sessionCompleted: this.sessionCompleted === 'Yes',
      sessionId: this.selectedSession!.id,
      remarks: this.feedbackRemarks!,
      sessionStatus: this.selectedStatus,
    };
    this.feedbackSubmitEvent.emit(request);
  }

  submitUpdateAppointment() {
    if (!this.selectedSession) {
      return;
    }
    this.selectedTherapistString = this.selectedTherapistString!.trim()!;
    if (!this.selectedTherapistString) {
      this.toastService.showAnyoErrorToast('Please Select Therapist');
      return;
    }
    const timeMoment = moment(this.startTime, 'hh:mm A');
    const selectedDateTime = moment(this.updateDate).set({
      hour: timeMoment.hour(),
      minute: timeMoment.minute(),
      second: 0,
      millisecond: 0,
    });
    const combinedEpoch = selectedDateTime.format('x');
    const request = {
      startTime: combinedEpoch,
      therapistId: this.selectedTherapistString,
      sessionId: this.selectedSession!.id,
    };
    this.updateAppointmentEvent.emit(request);
  }

  resetFilter() {
    this.resetFilterEvent.emit();
  }

  nzPageIndexChange(page: number) {
    this.pageChangeEvent.emit(page);
  }

  clientSearchFn() {
    this.clientSearchEvent.emit(this.clientPhoneEmailSearch);
  }

  setTherapistFilterData(filterOptions?: SessionGridFilterData) {
    this.therapistCheckBoxOptions = [];
    filterOptions?.therapists.forEach((th) => {
      if (
        !th.tags.includes(TherapistTags.TEST_THERAPIST) ||
        this.showTestBookings
      ) {
        if (this.tableQuery!.filters?.THERAPIST_EMAIL?.includes(th.id)) {
          this.therapistCheckBoxOptions.push({
            checked: true,
            label: th.name,
            value: th.id,
            data: th,
          });
        } else {
          this.therapistCheckBoxOptions.push({
            checked: false,
            label: th.name,
            value: th.id,
            data: th,
          });
        }
      }
    });
    this.therapistCheckBoxOptions.sort((a, b) =>
      a.label.charAt(0).localeCompare(b.label.charAt(0)),
    );
  }

  setPartnerNameFilterData(filterOptions?: SessionGridFilterData) {
    this.partnerCompanyNameCheckBoxOptions = [];
    filterOptions?.partners.forEach((th) => {
      if (this.tableQuery!.filters?.PARTNER_ID?.includes(th.partnerId)) {
        this.partnerCompanyNameCheckBoxOptions.push({
          checked: true,
          label: th.partnerId + '-' + th.companyName,
          value: th.partnerId,
        });
      } else {
        this.partnerCompanyNameCheckBoxOptions.push({
          checked: false,
          label: th.partnerId + '-' + th.companyName,
          value: th.partnerId,
        });
      }
    });
  }

  setSessionTagFilterData(filterOptions?: SessionGridFilterData) {
    this.sessionTagFilterOption = [];
    Object.values(SessionTags).forEach((th) => {
      if (this.tableQuery!.filters?.SESSION_TAG?.includes(th)) {
        this.sessionTagFilterOption.push({
          checked: true,
          label: th,
          value: th,
        });
      } else {
        this.sessionTagFilterOption.push({
          checked: false,
          label: th,
          value: th,
        });
      }
    });
  }

  setSessionStatusFilterData(filterOptions?: SessionGridFilterData) {
    this.sessionStatusCheckBoxOptions = [];
    filterOptions?.sessionStatus.forEach((status) => {
      if (this.tableQuery!.filters?.SESSION_STATUS?.includes(status)) {
        this.sessionStatusCheckBoxOptions.push({
          checked: true,
          label: status,
          value: status,
        });
      } else {
        this.sessionStatusCheckBoxOptions.push({
          checked: false,
          label: status,
          value: status,
        });
      }
    });
  }

  addRewardForm: FormGroup;

  constructor(
    private router: Router,
    private auth: AuthService,
    private sessionService: SessionsService,
    private toastService: ToastService,
    public utils: UtilsService,
    public therapyPlanService: TherapyPlansService,
    public therapyPacksService: PackService,
    private therapistService: TherapistService,
    private masterDataService: MasterdataService,
    private rewardService: RewardService,
    private fb: FormBuilder,
  ) {
    this.addRewardForm = this.fb.group({
      amount: [null, [Validators.required]],
      transactionDirection: [null, [Validators.required]],
      description: [null, [Validators.required]],
    });
  }

  remarkForPastSession: string = '';
  showRemarkForm = false;
  addRemarkForPastUserLoading = false;

  closeRemarkForm() {
    this.showRemarkForm = false;
  }

  openRemarkForm(data: SessionGridResponseData) {
    this.showRemarkForm = true;
    this.selectedSession = data;
  }

  addRemarkForPastUser() {
    this.addRemarkForPastUserLoading = true;
    const request: SessionAddRemarkRequest = {
      sessionId: this.selectedSession!.id!,
      remarks: this.remarkForPastSession,
    };
    this.sessionService.addRemarkForPastSession(request).subscribe({
      next: () => {
        this.addRemarkForPastUserLoading = false;
        this.showRemarkForm = false;
        this.remarkForPastSession = '';
        this.reloadTableEvent.emit();
        this.toastService.showSuccess('Successfully Remarks Added');
      },
      error: (error) => {
        this.addRemarkForPastUserLoading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(
          'Error while adding therapists remarks' + errorBody.description,
        );
      },
    });
  }

  dateFilterFn() {
    this.sessionDateFilterEvent.emit(this.sessionColumnFilterDate);
  }

  sortSessionDates(sort: string | null) {
    this.sessionDateSortEvent.emit(sort);
  }

  sortTherapistRating(sort: string | null) {
    this.therapistRatingSortEvent.emit(sort);
  }

  sessionStatusFilterChangeFn($event: string[]) {
    this.selectedSessionFilterStatus = $event;
  }

  formatSessionDate(date?: string | undefined) {
    if (!date) {
      return 'N/A';
    }
    return moment(date, 'x').format('DD/MM/yyyy');
  }
  formatSessionTime(date: string) {
    return moment(date, 'x').format('hh:mm A');
  }

  sessionStatusFilterFn() {
    this.sessionStatusFilterEvent.emit(this.selectedSessionFilterStatus);
  }

  onSessionTimeChange($event: Date[]) {
    this.sessionColumnFilterDate = $event;
  }

  therapistFilterChangeFn($event: string[]) {
    this.selectedTherapists = $event;
  }

  nzPageSizeChange(pageSize: number) {
    this.pageSizeChangeEvent.emit(pageSize);
  }

  therapistFilterFn() {
    this.therapistFilterEvent.emit(this.selectedTherapists);
  }

  hasCloudflareTag(tags?: string[]): boolean {
    return !!tags?.some((tag) => tag === SessionTags.CLOUDFLARE_BOOKING);
  }

  assignGoogleMeetFn(id: string) {
    this.assignGoogleMeetEvent.emit(id);
  }

  confirmAppointmentFn(id: string) {
    this.confirmAppointmentEvent.emit(id);
  }

  cancelAppointmentFn(id: string, userName: string, userEmail: string) {
    const data = {
      userName: userName,
      userEmail: userEmail,
      id: id,
    };
    this.cancelAppointmentEvent.emit(data);
  }
  UpdateAppointmentFn(data: SessionGridResponseData) {
    this.selectedSession = data;
    this.selectedTherapistString = data.therapistDetails.id;
    this.selectedTherapist = data.therapistDetails.id;
    this.startTime = moment(data.sessionStart, 'x').toDate();
    const dateMoment = moment(data.sessionDate, 'x');
    const dateObject = dateMoment.toDate();
    this.updateDate = dateObject;
    this.visibleUpdateAppointment = true;

    // Calculate duration in minutes
    const durationMin =
      (Number(data.sessionEnd) - Number(data.sessionStart)) / 60000;
    this.selectedDuration = isNaN(durationMin) ? 30 : durationMin;

    this.onUpdateAppointmentDatechange(dateObject);
  }

  onUpdateTherapistChange(event: string) {
    this.selectedTherapistString = event;
    this.onUpdateAppointmentDatechange(this.updateDate);
  }

  onUpdateAppointmentDatechange(dateObject: Date) {
    const request = {
      therapistId: this.selectedTherapistString || '',
      date: moment(dateObject).format('x'),
    };
    this.therapistService.getTimeRangesForSelectedDay(request).subscribe({
      next: (therapistTimeSlots) => {
        this.checkBoxTimeRangeOptions = [];
        therapistTimeSlots.forEach((timeSlot: TimeRangesResponse) => {
          const isUnavailable =
            !timeSlot.available || timeSlot.notAvailableSlotExists;
          this.checkBoxTimeRangeOptions.push({
            label: `${timeSlot.start} - ${timeSlot.end}`,
            value: timeSlot,
            checked: false,
            disabled: isUnavailable,
            isOverlapUnavailable: false,
          });
        });
        this.refreshTimeSlots();

        this.toastService.showSuccess('Time Ranges For the Day Of Therapist');
        this.searchSpinner = false;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
        this.searchSpinner = false;
      },
    });
  }

  viewDetailsFn(id: string) {
    this.viewPatientDetailsEvent.emit(id);
  }

  onExpandChange(id: string, checked: boolean) {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  showConfirmButton(status: AppointmentStatus) {
    return [
      AppointmentStatus.NEW_REQUEST,
      AppointmentStatus.THERAPIST_RESCHEDULE_REQUESTED,
      AppointmentStatus.CANCELLATION_REQUESTED,
    ].includes(status);
  }

  showCancelButton(status: AppointmentStatus) {
    return [
      AppointmentStatus.CONFIRMED,
      AppointmentStatus.NEW_REQUEST,
      AppointmentStatus.THERAPIST_RESCHEDULE_REQUESTED,
      AppointmentStatus.CANCELLATION_REQUESTED,
    ].includes(status);
  }

  showUpdateButton(status: AppointmentStatus) {
    return [AppointmentStatus.CONFIRMED].includes(status);
  }

  showRemarkButton(status: AppointmentStatus, endTime: string) {
    // return (
    //   moment().isAfter(moment(endTime, 'x')) &&
    //   ![
    //     AppointmentStatus.CONFIRMED,
    //     AppointmentStatus.FEEDBACK_PENDING,
    //     AppointmentStatus.MISSED_APPOINTMENT,
    //   ].includes(status)
    // );
    return true;
  }

  showAddLedgerAmountButton(status: AppointmentStatus) {
    return [
      AppointmentStatus.COMPLETED,
      AppointmentStatus.CANCELLED,
      AppointmentStatus.MISSED_APPOINTMENT,
      AppointmentStatus.NO_SHOW_THERAPIST,
      AppointmentStatus.NO_SHOW_USER,
      AppointmentStatus.TECH_ISSUE,
      AppointmentStatus.TECH_ISSUE,
    ].includes(status);
  }

  showRescheduleDeclineButton(status: AppointmentStatus) {
    return [AppointmentStatus.THERAPIST_RESCHEDULE_REQUESTED].includes(status);
  }

  appointmentRescheduleDeclineRequestFn(data: SessionGridResponseData) {
    if (data.remarks === undefined || data.remarks.length === 0) {
      return;
    }
    const latestLog = data.therapistRescheduleRequestedLogs?.sort((a, b) =>
      moment(b.addedAt).diff(moment(a.addedAt)),
    )[0];

    if (latestLog?.startTime) {
      this.sessionService
        .rescheduleDeclineAppointment(data.id, {
          therapistId: [data.therapistDetails.id],
          startTime: moment(latestLog.startTime).format('x'),
        })
        .subscribe({
          next: (response) => {
            this.toastService.showSuccess(
              'Appointment Reschedule Declined Successfully',
            );
            this.reloadTableEvent.emit();
          },
          error: (error) => {
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
          },
        });
    }
  }

  showFeedbackPendingButton(status: AppointmentStatus, endTime: string) {
    return (
      moment().isAfter(moment(endTime, 'x')) &&
      [
        AppointmentStatus.CONFIRMED,
        AppointmentStatus.FEEDBACK_PENDING,
        AppointmentStatus.MISSED_APPOINTMENT,
      ].includes(status)
    );
  }

  showFeedBackFormFn(data: SessionGridResponseData) {
    this.selectedSession = data;
    this.showFeedBackForm = true;
    this.feedbackRemarks = '';
    if (data.sessionStatus === AppointmentStatus.MISSED_APPOINTMENT) {
      this.selectedStatus = AppointmentStatus.MISSED_APPOINTMENT;
      this.sessionCompleted = 'No';
    }
  }

  closeFeedbackForm() {
    this.showFeedBackForm = false;
  }

  sessionOkDisabled: boolean = true;
  selectedSessionDate: Date | undefined;
  userSearchResults: AutocompleteDataSourceItem[] = [];
  userSearchResultsResponse: SearchUserResponse[] = [];
  selectedTherapist: string | undefined;
  emergencyBooking: boolean = false;
  searchSpinner: boolean = false;
  selectedSessionTime: Date | undefined;
  date: any;
  showTestBookings: boolean = false;
  fetchPlansLoading: boolean = false;

  setPartnerIdFilterData(filterOptions?: SessionGridFilterData) {
    this.partnerIdCheckBoxOptions = [];
    filterOptions?.partnerId.forEach((status) => {
      if (this.tableQuery!.filters?.PARTNER_ID?.includes(status)) {
        this.partnerIdCheckBoxOptions.push({
          checked: true,
          label: status,
          value: status,
        });
      } else {
        this.partnerIdCheckBoxOptions.push({
          checked: false,
          label: status,
          value: status,
        });
      }
    });
  }

  getColumnName() {
    return this.selectedSession?.sessionStatus ===
      AppointmentStatus.THERAPIST_RESCHEDULE_REQUESTED ||
      this.selectedSession?.sessionStatus.includes(
        SessionTags.THERAPIST_CANCELATION_REQUESTED,
      )
      ? 'Therapist'
      : 'User';
  }

  exportData() {
    this.exportDataEvent.emit();
  }
  sessionCompletedChangeFn($event: string) {}

  isSessionCompleted() {
    return this.sessionCompleted === 'Yes';
  }

  closeRewardsModal() {
    this.selectedSession = undefined;
    this.showRemarksModal = false;
  }

  onSessionFilterDateChange($event: Date[]) {
    this.sessionColumnFilterDate = $event;
  }

  showRemarksModalFn(data: SessionGridResponseData) {
    this.selectedSession = data;
    this.showRemarksModal = true;
  }

  showNewSessionFn() {
    this.showNewSessionModal = true;
    this.sessionService.getActiveTherapists().subscribe({
      next: (response) => {
        this.activeTherapists = response;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(
          'Error while fetching active therapists' + errorBody.description,
        );
      },
    });
  }

  showNewSessionPacksModal = false;
  showNewSessionPackFn() {
    this.showNewSessionPacksModal = true;
  }

  submitNewSessionFn() {
    this.newSessionSubmitProgress = true;
    if (!this.selectedActivePlan) {
      this.toastService.showAnyoErrorToast('Please select a plan');
      this.newSessionSubmitProgress = false;
      return;
    }
    const timeMoment = moment(this.selectedSessionTime, 'hh:mm A');
    const selectedDateTime = moment(this.selectedSessionDate).set({
      hour: timeMoment.hour(),
      minute: timeMoment.minute(),
      second: 0,
      millisecond: 0,
    });
    if (selectedDateTime.isBefore(moment())) {
      this.toastService.showAnyoErrorToast('Date should be in future');
      this.newSessionSubmitProgress = false;
      return;
    }
    if (!this.selectedUser) {
      this.newSessionSubmitProgress = false;
      this.toastService.showError('Please select a user');
      return;
    }
    if (!this.selectedTherapist) {
      this.newSessionSubmitProgress = false;
      this.toastService.showError('Please select a therapist');
      return;
    }
    const request: AdminTherapistBookingRequest = {
      appointmentDateTime: Number(selectedDateTime.format('x')),
      appointmentServiceType: AppointmentServiceType.Therapist,
      emergencyAppointment: false,
      therapistId: this.selectedTherapist!,
      userEmail: this.selectedUser,
      planSubscriptionId: this.selectedActivePlan.id,
      offline: !this.onlinePlans,
    };

    // Only send sessionMinutes when necessary; otherwise allow server defaults
    if (this.isIntroSession) {
      request.sessionMinutes = this.selectedDuration || 20;
    } else if (this.check60MinIsAvailable() && this.selectedDuration) {
      request.sessionMinutes = this.selectedDuration;
    }
    if (this.isIntroSession) {
      request.sessionMinutes = this.selectedDuration || 20;
    } else if (this.check60MinIsAvailable() && this.selectedDuration) {
      request.sessionMinutes = this.selectedDuration;
    }

    this.newSessionSubmitProgress = false;
    this.sessionService.adminSessionBooking(request).subscribe({
      next: (response) => {
        this.toastService.showSuccess('Session booked successfully');
        this.newSessionSubmitProgress = false;
        this.showNewSessionModal = false;
        this.closeNewSessionModal();
      },
      error: (error) => {
        this.newSessionSubmitProgress = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  submitNewPackSessionFn() {
    this.newSessionSubmitProgress = true;
    if (!this.selectedActivePack) {
      this.toastService.showAnyoErrorToast('Please select a pack');
      this.newSessionSubmitProgress = false;
      return;
    }
    const timeMoment = moment(this.selectedSessionTime, 'hh:mm A');
    const selectedDateTime = moment(this.selectedSessionDate).set({
      hour: timeMoment.hour(),
      minute: timeMoment.minute(),
      second: 0,
      millisecond: 0,
    });
    if (selectedDateTime.isBefore(moment())) {
      this.toastService.showAnyoErrorToast('Date should be in future');
      this.newSessionSubmitProgress = false;
      return;
    }
    if (!this.selectedUser) {
      this.newSessionSubmitProgress = false;
      this.toastService.showError('Please select a user');
      return;
    }
    if (!this.selectedTherapist) {
      this.newSessionSubmitProgress = false;
      this.toastService.showError('Please select a therapist');
      return;
    }
    const primaryTherapist = this.selectOptionsPacks.find(
      (data) => data.value === this.selectedTherapist,
    );
    const request: AdminTherapistBookingRequest = {
      appointmentDateTime: Number(selectedDateTime.format('x')),
      appointmentServiceType: AppointmentServiceType.Therapist,
      emergencyAppointment: false,
      therapistId: this.selectedTherapist!,
      userEmail: this.selectedUser,
      packSubscriptionId: this.selectedActivePack.id,
      primaryTherapist: primaryTherapist?.primary,
      offline: !this.onlinePacks,
    };
    this.selectedActivePack;
    if (this.check60MinIsAvailableForPacks()) {
      request.sessionMinutes = this.selectedDuration;
    }
    this.newSessionSubmitProgress = false;
    this.sessionService.adminSessionPacksBooking(request).subscribe({
      next: (response) => {
        this.toastService.showSuccess('Session booked successfully');
        this.newSessionSubmitProgress = false;
        this.showNewSessionPacksModal = false;
        this.closeNewSessionPackModal();
      },
      error: (error) => {
        this.newSessionSubmitProgress = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  // showNewBookingButton$ = this.auth.currentAuthStatus.pipe(
  //   map((user) => {
  //     if (
  //       user &&
  //       user.customClaims &&
  //       user.customClaims.additionalPermissions
  //     ) {
  //       return user.customClaims.additionalPermissions.includes(
  //         Permissions.AdminBookNewSession,
  //       );
  //     } else {
  //       return false;
  //     }
  //   }),
  // );

  async showNewBookingButton(): Promise<boolean> {
    try {
      const user = await this.getCurrentAuthUser();
      if (
        user &&
        user.customClaims &&
        user.customClaims.additionalPermissions
      ) {
        return user.customClaims.additionalPermissions.includes(
          Permissions.AdminBookNewSession,
        );
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      return false;
    }
  }

  private async getCurrentAuthUser() {
    if (this.auth.currentUser) {
      return this.auth.currentUser;
    }
    return await firstValueFrom(this.auth.currentAuthStatus);
  }

  onSearchUser($event: Event) {
    const searchText = ($event.target as HTMLInputElement).value;
    if (searchText.length > 3) {
      this.searchSpinner = true;
      this.sessionService.adminSearchUsers(searchText).subscribe({
        next: (response) => {
          this.searchSpinner = false;
          this.userSearchResults = [];
          this.userSearchResultsResponse.push(...response);
          response.forEach((value) => {
            this.userSearchResults.push({
              value: value.email,
              label: value.email,
            });
          });
        },
        error: (error) => {
          this.searchSpinner = false;
          const errorBody = error.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
        },
      });
    }
  }

  filteredAvailableSlotsArray: SlotAvailability[] = [];
  checkBoxTimeRangeOptions: CheckboxOptions[] = [];
  prevCheckBoxTimeRangeOptions: CheckboxOptions[] = [];

  onChange(result: Date) {
    this.searchSpinner = true;
    const request = {
      therapistId: this.selectedTherapist || '',
      date: moment(result).format('x'),
    };
    this.therapistService.getTimeRangesForSelectedDay(request).subscribe({
      next: (therapistTimeSlots) => {
        this.checkBoxTimeRangeOptions = [];
        therapistTimeSlots.forEach((timeSlot: TimeRangesResponse) => {
          const isUnavailable =
            !timeSlot.available || timeSlot.notAvailableSlotExists;
          this.checkBoxTimeRangeOptions.push({
            label: `${timeSlot.start} - ${timeSlot.end}`,
            value: timeSlot,
            checked: false,
            disabled: isUnavailable,
            isOverlapUnavailable: false,
          });
        });
        this.refreshTimeSlots();
        console.log('checkBoxTimeRangeOptions', this.checkBoxTimeRangeOptions);
        console.log('this.selectedDuration', this.selectedDuration);
        this.toastService.showSuccess('Time Ranges For the Day Of Therapist');
        this.searchSpinner = false;
      },
      error: (error) => {
        this.bookSessionDateTimeSpinner = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
        this.searchSpinner = false;
      },
    });
  }

  onCheckboxChange(selectedItem: any) {
    this.checkBoxTimeRangeOptions.forEach((item) => {
      item.checked = item.value.start === selectedItem.value.start;
    });
    this.onUpdateSessionTimeChange(
      moment(selectedItem.value.start, 'hh:mm A').toDate(),
    );
  }

  onNewSessionDateChange($event: Date) {
    if (!moment($event).startOf('day').isSameOrAfter(moment().startOf('day'))) {
      this.toastService.showError('Date should be in future');
      return;
    }
    this.selectedSessionDate = $event;
    this.onChange($event);
  }

  close() {
    this.activateNewPlanModal = false;
  }

  isAnyChecked = false;

  onNewSessionTimeChange($event: TimeRangesResponse[]) {
    if ($event && $event.length > 0) {
      this.selectedSessionTime = moment($event[0].start, 'hh:mm a').toDate();
    }

    if (this.selectedSessionDate && this.selectedSessionTime) {
      this.sessionOkDisabled = false;
    }

    // this.isAnyChecked = this.checkBoxTimeRangeOptions.some(
    //   (option) => option.checked,
    // );

    // if (this.isAnyChecked) {
    //   const index = this.checkBoxTimeRangeOptions.findIndex((data) => data.checked );
    //   this.checkBoxTimeRangeOptions.forEach((data) => {
    //   data.checked = false;
    // })
    //   this.checkBoxTimeRangeOptions[index].checked = true
    // }
  }

  onCheckboxClick($event: boolean, selectedIndex: number) {
    this.checkBoxTimeRangeOptions.forEach((option, index) => {
      option.checked = index === selectedIndex;
    });
  }

  onUpdateSessionTimeChange($event: Date) {
    this.startTime = $event;
    if (this.startTime && this.updateDate) {
      this.sessionOkDisabled = false;
    }
  }

  onUpdateSessionDateChange($event: Date) {
    if (moment($event).isBefore(moment().startOf('day'))) {
      this.toastService.showError('Date should be in future');
      return;
    }
    this.updateDate = $event;
    this.onUpdateAppointmentDatechange(this.updateDate);
  }

  testBookingChangeFn() {
    this.hideTestBookingEvent.emit(this.showTestBookings);
  }

  openUserSessionPage(email: string) {
    const isAdminPortal = this.router.routerState.snapshot.url.includes(
      'therapist/session/admin',
    );
    window.open(
      `${
        isAdminPortal ? 'therapist/session/admin' : '/sessions/therapist'
      }?userId=${email}`,
    );
  }

  openTherapyPlansSubscriptionPageByPlanName(planName: string) {
    const isAdminPortal = this.router.routerState.snapshot.url.includes(
      'therapist/session/admin',
    );
    window.open(
      `${
        isAdminPortal ? 'therapy-plans/subscriptions' : '/sessions/therapist'
      }?planName=${planName}`,
    );
  }

  openTherapyPlansSubscriptionPageByUser(userId: string) {
    const isAdminPortal = this.router.routerState.snapshot.url.includes(
      'therapist/session/admin',
    );
    window.open(
      `${
        isAdminPortal ? 'therapy-plans/subscriptions' : '/sessions/therapist'
      }?userId=${userId}`,
    );
  }

  openTherapyPacksSubscriptionPageByUser(userId: string) {
    window.open(`packs/subscription?userId=${userId}`);
  }

  openTherapistSessionsPage(email: string) {
    const isAdminPortal = this.router.routerState.snapshot.url.includes(
      'therapist/session/admin',
    );
    window.open(
      `${
        isAdminPortal ? 'therapist/session/admin' : '/sessions/therapist'
      }?therapistId=${email}`,
    );
  }

  openClients(userId: string) {
    window.open(`/experts/manage-clients/${userId}`, '_blank');
  }

  partnerIdFilterChangeFn($event: string[]) {
    this.selectedPartId = $event;
    this.partnerIdFilterEvent.emit(this.selectedPartId);
  }

  sessionTagFilterChangeFn($event: string[]) {
    this.selectedSessionTag = $event;
    this.sessionFilterTagEvent.emit(this.selectedSessionTag);
  }

  partnerNameFilterChangeFn($event: string[]) {
    this.partnerNameFilterEvent.emit($event);
  }
  activateNewPlanLoading = false;
  activateNewPlanModal = false;
  verticals: TherapyVerticals[] = [];
  concerns: TherapyConcerns[] = [];
  filteredConcerns: TherapyConcerns[] = [];
  selectedVerticalId: string | undefined;
  selectedConcernId: string | undefined;
  selectedVertical: TherapyVerticals | undefined;
  selectedConcern: TherapyConcerns | undefined;
  selectedPlanId: string | undefined;
  selectedPlan: TherapyPlansAppResponse | undefined;
  plansForSelectedConcern: TherapyPlansAppResponse[] = [];
  paymentOrderId: string | undefined;
  onVerticalChange($event: any) {
    this.selectedVertical = this.verticals.find(
      (vertical) => vertical.m_id === $event,
    );

    this.filteredConcerns = this.concerns.filter((concern) =>
      concern.verticalId.includes(this.selectedVertical!.m_id),
    );
  }
  onPlanChange($event: any) {
    this.selectedPlan = this.plansForSelectedConcern.find(
      (plan) => plan.planId === $event,
    );
  }
  onConcernChange($event: any) {
    this.selectedConcern = this.filteredConcerns.find(
      (concern) => concern.m_id === $event,
    );
    if (!this.selectedConcern) {
      this.toastService.showError('Please select a valid concern');
      return;
    }
    if (!this.selectedVertical) {
      this.toastService.showError('Please select a valid vertical');
      return;
    }
    this.fetchPlansLoading = true;
    this.therapyPlanService.getTherapistsForTransfer({
      verticalId: this.selectedVertical.m_id,
      concernId: this.selectedConcern.m_id,
    });
    this.therapyPlanService
      .getTherapistsForTransfer({
        verticalId: this.selectedVertical.m_id,
        concernId: this.selectedConcern.m_id,
      })
      .subscribe({
        next: (response) => {
          this.therapistByVerticalConcern = response;
          this.therapistByVerticalConcern = response;
          this.fetchPlansLoading = false;
        },
        error: (error) => {
          this.fetchPlansLoading = false;
          const errorBody = error.error as IAnyoError;
          this.toastService.showAnyoErrorToast(
            'Error while fetching plans for concern' + errorBody.description,
          );
        },
      });
  }

  showActivateNewPlaModal() {
    this.verticals = this.masterData!.therapyVerticals
      ? this.masterData!.therapyVerticals
      : [];
    this.concerns = this.masterData!.therapyConcerns
      ? this.masterData!.therapyConcerns
      : [];
    this.sessionService.getActiveTherapists().subscribe({
      next: (response) => {
        this.activeTherapists = response;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(
          'Error while fetching active therapists' + errorBody.description,
        );
      },
    });
    this.activateNewPlanModal = true;
  }
  hideActivateNewPlanModal() {
    this.activateNewPlanModal = false;
  }
  activateNewPlan() {
    if (!this.selectedConcern) {
      this.toastService.showError('Please select a valid concern');
      return;
    }
    if (!this.selectedVertical) {
      this.toastService.showError('Please select a valid vertical');
      return;
    }
    if (!this.selectedTherapist) {
      this.toastService.showError('Please select a valid therapist');
      return;
    }
    if (!this.selectedUserId) {
      this.toastService.showError('Please select a valid user');
      return;
    }
    if (!this.selectedPlan) {
      this.toastService.showError('Please select a valid plan');
      return;
    }
    this.activateNewPlanLoading = true;

    const activatePlanRequest = {
      planId: this.selectedPlan.planId,
      therapistId: this.selectedTherapist,
      userId: this.selectedUserId,
      concernId: this.selectedConcern.m_id,
      verticalId: this.selectedVertical.m_id,
      paymentOrderId: this.paymentOrderId?.trim(),
    };
    this.therapyPlanService
      .activateAdminTherapySession(activatePlanRequest)
      .subscribe({
        next: () => {
          this.activateNewPlanLoading = false;
          this.toastService.showInfo('Plan activated successfully');
          this.selectedUserId = undefined;
          this.selectedTherapist = undefined;
          this.selectedConcern = undefined;
          this.selectedVertical = undefined;
          this.selectedPlan = undefined;
          this.activateNewPlanModal = false;
        },
        error: (error) => {
          this.activateNewPlanLoading = false;
          const errorBody = error.error as IAnyoError;
          this.toastService.showAnyoErrorToast(
            'Error while activating plan' + errorBody.description,
          );
        },
      });
  }

  therapistSelectedFn($event: any) {
    if (!this.selectedConcern) {
      this.toastService.showError('Please select a valid concern');
      return;
    }
    if (!this.selectedVertical) {
      this.toastService.showError('Please select a valid vertical');
      return;
    }
    if (!this.selectedTherapist) {
      this.toastService.showError('Please select a valid therapist');
      return;
    }
    if (!this.selectedUserId) {
      this.toastService.showError('Please select a valid user');
      return;
    }
    this.therapyPlanService
      .fetchPlansForConcernVertical(
        this.selectedVertical.m_id,
        this.selectedConcern.m_id,
        this.selectedTherapist,
        this.selectedUserId,
      )
      .subscribe({
        next: (response) => {
          this.plansForSelectedConcern = response;
          this.fetchPlansLoading = false;
        },
        error: (error) => {
          this.fetchPlansLoading = false;
          const errorBody = error.error as IAnyoError;
          this.toastService.showAnyoErrorToast(
            'Error while fetching plans for concern' + errorBody.description,
          );
        },
      });
  }

  availableSlots: Record<string, SlotAvailability[]> | undefined;

  therapistSelectedNewSessionFn($event: any) {
    if (this.selectedUser && this.selectedTherapist) {
      this.bookSessionDateTimeSpinner = true;
      this.sessionService
        .getAvailableSlotsTherapist(this.selectedTherapist, this.selectedUser)
        .subscribe({
          next: (response) => {
            this.bookSessionDateTimeSpinner = false;
            this.availableSlots = response;
          },
          error: (error) => {
            this.searchSpinner = false;
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
          },
        });
    }
  }
  isIntroSession: boolean = false;
  onUserSelectFn($event: any) {
    this.selectedUserId = this.userSearchResultsResponse.find(
      (value) => value.email === $event,
    )?.id;
  }
  selectedActivePlanId: string | undefined;
  selectedActivePlan: ActiveTherapyPlansResponse | undefined;
  userActivePlans: ActiveTherapyPlansResponse[] = [];
  onActivePlanSelected($event: any) {
    if (!$event) {
      return;
    }

    this.selectedActivePlan = this.userActivePlans.find(
      (plan) => plan.id === $event,
    );
    // Reset intro-session state before evaluating
    this.isIntroSession = false;
    this.selectedDuration = 30;

    console.log('this.selectedActivePlan', this.selectedActivePlan);
    // Determine if an intro session is pending (not booked or completed)
    const sessionDetails = this.selectedActivePlan?.sessionDetails || {};
    let isIntroPending = false;
    let introSessionMinutes = 20;

    Object.keys(sessionDetails).forEach((key) => {
      const sd = sessionDetails[key];
      if (sd?.isIntroSession && !sd.sessionBooked && !sd.sessionCompleted) {
        isIntroPending = true;
        introSessionMinutes = sd.sessionMinutes || 20;
      }
    });

    if (isIntroPending) {
      this.isIntroSession = true;
      this.selectedDuration = introSessionMinutes;
    } else {
      // Find the 1st occurrence of sessionBooked === false && sessionCompleted === false
      const sortedKeys = Object.keys(sessionDetails).sort((a, b) => {
        const numA = Number(a);
        const numB = Number(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.localeCompare(b);
      });

      for (const key of sortedKeys) {
        const sd = sessionDetails[key];
        if (sd && !sd.sessionBooked && !sd.sessionCompleted) {
          this.selectedDuration = sd.sessionMinutes || 30;
          break;
        }
      }
    }

    this.refreshTimeSlots();

    this.selectedTherapist =
      this.selectedActivePlan?.therapistDetails.therapistId;
    this.therapistSelectedNewSessionFn(this.selectedTherapist);
  }

  selectedActivePackId: string | undefined;
  selectedActivePack: AnyoPackSubscriptionAppResponse | undefined;
  userActivePacks: AnyoPackSubscriptionAppResponse[] = [];
  selectOptionsPacks: { label: string; value: string; primary: boolean }[] = [];
  onActivePackSelected($event: string) {
    if (!$event) {
      return;
    }
    const packs = this.userActivePacks.find((data) => data.id === $event);
    this.selectedActivePack = packs;
    // Push primary therapist
    if (this.selectedActivePack?.primaryConcern?.therapistDetails) {
      this.selectOptionsPacks.push({
        label:
          this.selectedActivePack?.primaryConcern.concernName +
          ' - ' +
          this.selectedActivePack?.primaryConcern.therapistDetails
            .therapistName +
          '(Primary)',
        value:
          this.selectedActivePack?.primaryConcern.therapistDetails.therapistId,
        primary: true,
      });
    }
    // Push all auxiliary concern therapists
    if (this.selectedActivePack?.auxiliaryConcerns) {
      Object.values(this.selectedActivePack?.auxiliaryConcerns).forEach(
        (aux: any) => {
          if (aux.therapistDetails) {
            this.selectOptionsPacks.push({
              label:
                aux.concernName +
                ' - ' +
                aux.therapistDetails.therapistName +
                '(Secondary)',
              value: aux.therapistDetails.therapistId,
              primary: false,
            });
          }
        },
      );
    }
  }

  onSelectTherapistForPacks($event: any) {
    this.selectedTherapist = $event;
    this.therapistSelectedNewSessionFn(this.selectedTherapist);
    if (this.selectedSessionDate) {
      this.onChange(this.selectedSessionDate);
    }
  }

  check60MinIsAvailable = () => {
    return (
      this.masterData?.therapyVerticals.find(
        (d) => d.m_id === this.selectedActivePlan?.therapyVerticalId,
      )?.userSelectSessionDuration ||
      this.masterData?.therapyConcerns.find(
        (d) => d.m_id === this.selectedActivePlan?.therapyConcernId,
      )?.userSelectSessionDuration
    );
  };
  showMinsSelection = false;
  check60MinIsAvailableForPacks = () => {
    if (this.selectedActivePack && this.selectedTherapist) {
      if (
        this.selectedActivePack?.primaryConcern.therapistDetails.therapistId ===
        this.selectedTherapist
      ) {
        const userSelectSessionDuration = this.masterData?.therapyConcerns.find(
          (d) => d.m_id === this.selectedActivePack?.primaryConcern.concernId,
        )?.userSelectSessionDuration;
        if (userSelectSessionDuration) {
          return userSelectSessionDuration;
        }
      }

      let result = false;
      Object.values(this.selectedActivePack!.auxiliaryConcerns).forEach(
        (data) => {
          if (data.therapistDetails.therapistId === this.selectedTherapist) {
            result =
              this.masterData?.therapyConcerns.find(
                (d) => d.data === data.concernName,
              )?.userSelectSessionDuration || false;
          }
        },
      );
      return result;
      // const isAvailableForAny = Object.keys(
      //   this.selectedActivePack!.auxiliaryConcerns,
      // ).map((data) => {
      //   return this.masterData?.therapyConcerns.find((d) => d.m_id === data)
      //     ?.userSelectSessionDuration;
      // });
      // return (
      //   isAvailableForAny.some((data) => data)

      // );
    }
    return false;
  };
  onUserSelectedBookNewSession($event: any) {
    if (this.selectedUser) {
      this.selectedUserId = this.userSearchResultsResponse.find(
        (value) => value.email === $event,
      )?.id;
    }

    if (this.selectedUserId && this.showNewSessionModal) {
      this.therapyPlanService
        .fetchActiveTherapyPlansForUser(this.selectedUserId!)
        .subscribe({
          next: (response) => {
            this.userActivePlans = response;
          },
          error: (error) => {
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(
              'Error while fetching active plans for user' + errorBody,
            );
          },
        });
    }

    if (this.selectedUserId && this.showNewSessionPacksModal) {
      this.therapyPacksService
        .fetchActiveTherapyPacksForUser(this.selectedUserId!)
        .subscribe({
          next: (response) => {
            this.userActivePacks = response;
            // response.forEach((item) => {
            //   // Push primary therapist
            //   if (item.primaryConcern?.therapistDetails) {
            //     this.selectOptionsPacks.push({
            //       label:
            //         item.packMeta.name +
            //         ' - ' +
            //         item.primaryConcern.concernName +
            //         ' - ' +
            //         item.primaryConcern.therapistDetails.therapistName +
            //         '(Primary)',
            //       value: item.primaryConcern.therapistDetails.therapistId,
            //     });
            //   }

            //   // Push all auxiliary concern therapists
            //   if (item.auxiliaryConcerns) {
            //     Object.values(item.auxiliaryConcerns).forEach((aux: any) => {
            //       if (aux.therapistDetails) {
            //         this.selectOptionsPacks.push({
            //           label:
            //             item.packMeta.name +
            //             ' - ' +
            //             aux.concernName +
            //             ' - ' +
            //             aux.therapistDetails.therapistName +
            //             '(Secondary)',
            //           value: aux.therapistDetails.therapistId,
            //         });
            //       }
            //     });
            //   }
            // });
          },
          error: (error) => {
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(
              'Error while fetching active packs for user' + errorBody,
            );
          },
        });
    }
  }

  visibleMeetParticipant = false;
  dataMeetParticipant: MeetParticipant[] = [];

  closeMeetParticipant() {
    this.visibleMeetParticipant = false;
  }

  openMeetParticipant(dataMeetParticipant: MeetParticipant[]) {
    this.dataMeetParticipant = dataMeetParticipant;
    this.visibleMeetParticipant = true;
  }

  isAddRewardModalVisible = false;
  isAddRewardLoading = false;
  sessionId: string | undefined;

  openAddRewardModal(sessionId: string): void {
    this.isAddRewardModalVisible = true;
    this.sessionId = sessionId;
  }

  closeAddRewardModal(): void {
    this.isAddRewardModalVisible = false;
    this.addRewardForm.reset();
  }

  submitAddRewardForm(): void {
    if (this.addRewardForm.invalid) {
      this.addRewardForm.markAllAsTouched();
      return;
    }
    this.isAddRewardLoading = true;
    const formData = this.addRewardForm.value;
    const request: AdminAddRewardToLedger = {
      sessionId: this.sessionId!,
      amount: formData.amount,
      paymentTransactionType: formData.transactionDirection,
      description: formData.description,
    };
    this.rewardService.addRewardToLedger(request).subscribe({
      next: () => {
        this.isAddRewardLoading = false;
        this.isAddRewardModalVisible = false;
        this.addRewardForm.reset();
        this.toastService.showSuccess('Ledger Updated Successfully');
        this.reloadTableEvent.emit();
      },
      error: (error) => {
        this.isAddRewardLoading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(
          'Error while adding reward to ledger: ' + errorBody.description,
        );
      },
    });
  }

  syncMeetParticipantData(sessionId: string) {
    this.sessionService.syncMeetParticipantData(sessionId).subscribe({
      next: (value) => {
        this.toastService.showSuccess('Successfully synced');
        this.reloadTableEvent.emit();
      },
      error: (err) => {
        const errorBody = err.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  // --- Override Session Status ---

  readonly OVERRIDEABLE_SOURCE_STATUSES = [
    AppointmentStatus.TECH_ISSUE,
    AppointmentStatus.NO_SHOW_USER,
    AppointmentStatus.NO_SHOW_THERAPIST,
    AppointmentStatus.MISSED_APPOINTMENT,
    AppointmentStatus.COMPLETED,
    AppointmentStatus.FEEDBACK_PENDING,
    AppointmentStatus.CONFIRMED,
    AppointmentStatus.CANCELLED,
    AppointmentStatus.THERAPIST_RESCHEDULE_REQUESTED,
  ];

  readonly OVERRIDEABLE_TARGET_STATUSES = [
    AppointmentStatus.FEEDBACK_PENDING,
    AppointmentStatus.COMPLETED,
    AppointmentStatus.TECH_ISSUE,
    AppointmentStatus.NO_SHOW_USER,
    AppointmentStatus.NO_SHOW_THERAPIST,
    AppointmentStatus.MISSED_APPOINTMENT,
    AppointmentStatus.CANCELLED,
  ];

  readonly STATUS_OVERRIDE_RULES: Partial<
    Record<AppointmentStatus, AppointmentStatus[]>
  > = {
    [AppointmentStatus.CANCELLED]: [AppointmentStatus.FEEDBACK_PENDING],
  };
  showOverrideModal = false;
  overrideModalSession: SessionGridResponseData | undefined;
  overrideTargetStatus: string | undefined;
  overrideReason = '';
  overrideSubmitLoading = false;

  overrideSideEffects = {
    meetCancel: false,
    notifDelete: false,
  };

  private readonly MEET_CANCEL_TARGETS = [
    AppointmentStatus.TECH_ISSUE,
    AppointmentStatus.NO_SHOW_USER,
    AppointmentStatus.NO_SHOW_THERAPIST,
    AppointmentStatus.MISSED_APPOINTMENT,
  ];

  private readonly NOTIF_DELETE_TARGETS = [
    AppointmentStatus.TECH_ISSUE,
    AppointmentStatus.NO_SHOW_USER,
    AppointmentStatus.NO_SHOW_THERAPIST,
    AppointmentStatus.MISSED_APPOINTMENT,
  ];

  showSideEffect(key: keyof typeof this.overrideSideEffects): boolean {
    const target = this.overrideTargetStatus as AppointmentStatus | undefined;
    switch (key) {
      case 'meetCancel':
        return (
          target !== undefined && this.MEET_CANCEL_TARGETS.includes(target)
        );
      case 'notifDelete':
        return (
          target !== undefined && this.NOTIF_DELETE_TARGETS.includes(target)
        );
      default:
        return false;
    }
  }

  onOverrideTargetStatusChange() {
    // Reset side effects when target changes so stale selections don't carry over
    this.overrideSideEffects = {
      meetCancel: false,
      notifDelete: false,
    };
  }

  getOverrideTargetStatuses(): AppointmentStatus[] {
    const currentStatus = this.overrideModalSession?.sessionStatus;

    if (!currentStatus) return [];

    const allowedTargets =
      this.STATUS_OVERRIDE_RULES[currentStatus] ??
      this.OVERRIDEABLE_TARGET_STATUSES;

    return allowedTargets.filter((status) => status !== currentStatus);
  }

  canOverrideSession(status: AppointmentStatus): boolean {
    return this.OVERRIDEABLE_SOURCE_STATUSES.includes(status);
  }

  openOverrideModal(data: SessionGridResponseData) {
    this.overrideModalSession = data;
    this.overrideTargetStatus = undefined;
    this.overrideReason = '';
    this.overrideSideEffects = {
      meetCancel: false,
      notifDelete: false,
    };
    this.showOverrideModal = true;
  }

  closeOverrideModal() {
    this.showOverrideModal = false;
    this.overrideModalSession = undefined;
  }

  submitOverride() {
    if (
      !this.overrideModalSession ||
      !this.overrideTargetStatus ||
      !this.overrideReason.trim()
    ) {
      this.toastService.showError('Please fill in all required fields');
      return;
    }
    this.overrideSubmitLoading = true;
    const request: SessionOverrideRequest = {
      targetStatus: this.overrideTargetStatus,
      reason: this.overrideReason.trim(),
      sideEffects: { ...this.overrideSideEffects },
    };
    this.sessionService
      .overrideSessionStatus(this.overrideModalSession.id, request)
      .subscribe({
        next: () => {
          this.overrideSubmitLoading = false;
          this.closeOverrideModal();
          this.toastService.showSuccess(
            'Session status overridden successfully',
          );
          this.reloadTableEvent.emit();
        },
        error: (error) => {
          this.overrideSubmitLoading = false;
          const errorBody = error.error as IAnyoError;
          this.toastService.showAnyoErrorToast(
            'Override failed: ' + errorBody.description,
          );
        },
      });
  }

  // ── Policy Trace Drawer ──────────────────────────────────────────
  policyTraceDrawerVisible = false;
  selectedPolicyTrace: PolicyBookingTrace | null = null;
  selectedPolicyTraceSessionLabel = '';

  openPolicyTrace(session: SessionGridResponseData) {
    if (!session.policyTrace) return;
    this.selectedPolicyTrace = session.policyTrace;
    this.selectedPolicyTraceSessionLabel =
      session.clientDetails.name +
      ' · ' +
      moment(Number(session.sessionDate)).format('DD MMM YYYY, h:mm A');
    this.policyTraceDrawerVisible = true;
  }

  closePolicyTrace() {
    this.policyTraceDrawerVisible = false;
    this.selectedPolicyTrace = null;
  }

  policySessionAllowed(): boolean {
    if (!this.selectedPolicyTrace) return false;
    const val = this.selectedPolicyTrace.outputs.sessionAllowed;
    return val === true || val === 'true';
  }

  objectEntries(obj: Record<string, unknown>): [string, unknown][] {
    return Object.entries(obj || {});
  }

  winnerEntries(): [
    string,
    {
      ruleId: string;
      ruleName: string;
      priority: number;
      isGlobal: boolean;
    } | null,
  ][] {
    if (!this.selectedPolicyTrace) return [];
    return Object.entries(this.selectedPolicyTrace.winnersByField || {});
  }
}
